import React from 'react';
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

interface WaterStat {
  waterId: string;
  waterName: string;
  totalCatches: number;
  taken: number;
  released: number;
  unknown: number;
}

export const CatchStatsByWaterChart = ({data}: { data: WaterStat[] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="card h-100">
        <div className="card-header">
          <h3 className="card-title">Fänge pro Gewässer</h3>
        </div>
        <div className="card-body">
          <div className="text-muted">Keine Daten verfügbar</div>
        </div>
      </div>
    );
  }

  const top10 = data.slice(0, 10);

  return (
    <div className="card h-100">
      <div className="card-header">
        <h3 className="card-title">Fänge pro Gewässer</h3>
      </div>
      <div className="card-body">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={top10} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="waterName" type="category" width={120} />
            <Tooltip />
            <Legend />
            <Bar dataKey="taken" stackId="a" fill="#ef4444" name="Entnommen" />
            <Bar dataKey="released" stackId="a" fill="#10b981" name="Zurückgesetzt" />
            <Bar dataKey="unknown" stackId="a" fill="#6b7280" name="Unbekannt" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
